import React from "react";

const TradeData = () => {
  const summaries = [
    {
      name: "Total profits",
      amount: "$23,000.00",
      icon: "./assets/misc/wallet.svg",
    },
    {
      name: "Total deposits",
      amount: "$35,455.83",
      icon: "./assets/misc/wallet.svg",
      action: "Deposit",
    },
    {
      name: "Total withdrawals",
      amount: "$125,568.42",
      icon: "./assets/misc/wallet.svg",
      action: "Withdraw",
    },
  ];

  return (
    <div
      style={{
        // gridArea: "data",
        backgroundColor: "#151823",
        // maxHeight: "300px",
        height: "100%",
        borderRadius: "12px",
        // maxHeight: "250px",
        // height: "100%",
        overflowY: "auto",
        position: "relative",
        height: "max-content",
        // maxHeight: "100%",
        // marginTop: "24px",
        // padding: "24px",
      }}
      className="scrollbar-hide"
    >
      <div
        style={{
          color: "white",
          fontSize: "16px",
          fontWeight: "600",
          backgroundColor: "#1B1F2D",
          width: "100%",
          padding: "12px 16px",
          borderTopLeftRadius: "12px",
          borderTopRightRadius: "12px",
          position: "sticky",
          top: "0",
          zIndex: "999",
          left: "0",
        }}
      >
        Market history
      </div>

      <div
        className="summaries"
        style={{
          display: "grid",
          gap: "8px",
          padding: "8px",
          paddingTop: "0px",
        }}
      >
        {summaries.map((summary) => (
          <div
            style={{
              marginTop: "12px",
              display: "flex",
              justifyContent: "space-between",
              // backgroundColor: "#1C233B",
              padding: "16px",
              alignItems: "center",
              borderRadius: "6px",
            }}
          >
            <span style={{ display: "flex", gap: "12px", alignItems: "start" }}>
              <img src={summary.icon} alt="" />
              <span style={{ display: "grid", gap: "8px" }}>
                <p
                  style={{
                    display: "14px",
                    color: "#bac2de",
                    fontWeight: "600",
                  }}
                >
                  {summary.name}
                </p>
                <p
                  style={{
                    fontSize: "20px",
                    color: "white",
                    fontWeight: "600",
                  }}
                >
                  {summary.amount}
                </p>
              </span>
            </span>

            <span style={{ display: "block" }}>
              <button
                style={{
                  outline: "none",
                  border: "none",
                  borderRadius: "32px",
                  padding: " 8px 12px",
                  fontWeight: "600",
                  fontSize: "14px",
                  color: "#080A11",
                }}
              >
                Deposit
              </button>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TradeData;
